import { v4 as uuid } from "uuid";

export const FooterLinks = {
    categoryLinks: [
      {
        id: uuid(),
        linkName: "Bowls",
        url: "#",
      },
      {
        id: uuid(),
        linkName: "Cups",
        url: "#",
      },
      {
        id: uuid(),
        linkName: "Plates",
        url: "#",
      },
      {
        id: uuid(),
        linkName: "Planters",
        url: "#",
      },
      {
        id: uuid(),
        linkName: "Gifts",
        url: "#",
      },
    ]
}